import React from "react";
import { Styles } from "./styles";
import { Box, Button } from "@mui/material";
import MainDetails from "./main-details";
import UrlDetails from "./url-details";
import Services from "./services";
import Reviews from "./reviews";
import ContactData from "./main-details/contact-data";

const PanelDetails = ({ data }) => {
  return (
    <Styles>
      <Box className="panel-details-container">
        {/* PanelsDetails Section */}
        <MainDetails data={data} />
        <UrlDetails data={data} />
      </Box>
      <ContactData data={data} />
      <Services data={data} />
      <Reviews data={data} />
    </Styles>
  );
};

export default PanelDetails;
